// extracted by mini-css-extract-plugin
export var active = "_tv-1";
export var circle = "_tv-0";
export var completed = "_tv-2";
export var connector = "_tv-4";
export var connectorCompleted = "_tv-7";
export var connectorSpacer = "_tv-5";
export var iconStrokeOverride = "_tv-8";
export var labelContainer = "_tv-6";
export var pending = "_tv-3";